import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LocaleState } from './locale.state';

export const selectLocales = createFeatureSelector<LocaleState>('applicationLocale');

export const selectLocaleBySection = (section: string) =>
	createSelector(selectLocales, (localeState: LocaleState) => localeState.locales[section]);
